import { render } from "./FaqSectionEditor.vue?vue&type=template&id=4bc30001"
import script from "./FaqSectionEditor.vue?vue&type=script&lang=js"
export * from "./FaqSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__